import { DOCUMENT } from '@angular/common';
import {
	Component,
	EventEmitter,
	HostListener,
	Inject,
	Input,
	Output,
	ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import ClearcalsIcons from 'app/icons/icons.data';

@Component({
	selector: 'clearcals-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
	menuIcon = ClearcalsIcons.getIcon('menu');

	count = 0;
	openMenu: boolean;
	scrollAnchor: string;
	isHeaderSticky: boolean;

	@Input() currentSection: string;
	@Input() leftSidenavOpen: boolean;
	@Output() toggleSidenav = new EventEmitter<boolean>();

	constructor(
		private router: Router,
		@Inject('Window') private window: Window,
		@Inject(DOCUMENT) private document: Document,
	) {}

	@HostListener('window:scroll', [])
	onWindowScroll(): void {
		const offset =
			this.window.pageYOffset ||
			this.document.documentElement.scrollTop ||
			this.document.body.scrollTop ||
			0;

		if (offset > 10) {
			this.isHeaderSticky = true;
		} else {
			this.isHeaderSticky = false;
		}
	}

	toggleMenu(): void {
		this.toggleSidenav.emit(!this.leftSidenavOpen);
	}

	navigate(route): void {
		this.router.navigate([route]);
		this.toggleSidenav.emit(false);
	}

	openLink(url: string): void {
		window.open(url, '_blank');
	}
}
